import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-arrow-right-green.png'


const _withScopeId = n => (_pushScopeId("data-v-804a3464"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Order number: 123213"),
  /*#__PURE__*/_createElementVNode("div", { class: "status" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Shipped"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "icon-arrow"
    })
  ])
], -1))
const _hoisted_2 = { class: "order-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Discount: "),
    /*#__PURE__*/_createElementVNode("div", { class: "value" }, " $ 5.0 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "footer-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Actual payment: "),
    /*#__PURE__*/_createElementVNode("div", { class: "value" }, " $ 295.0 ")
  ])
], -1))

import { onMounted } from 'vue';
  import OrderProductItem from './order-product-item.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'mine.shop.myOrders.detail', params: { id: 16 } },
    class: "order-item-wrapper"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item) => {
          return _createVNode(OrderProductItem, { key: item })
        }), 64))
      ]),
      _hoisted_3
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})